// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"718":"0840458d","6301":"afc8df7e"}[chunkId] + ".chunk.css";
};